import { render, staticRenderFns } from "./RelationshipPanel.vue?vue&type=template&id=18430268&"
import script from "./RelationshipPanel.vue?vue&type=script&lang=js&"
export * from "./RelationshipPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports